import clsx from 'clsx'
import React, { useEffect, useMemo, useState } from 'react'

import Spinner from '@/components-latest/primitives/Spinner'
import Text from '@/components-latest/primitives/Text'

import Styles from './Avatar.module.scss'

type Props = {
  size?: 'small' | 'large' | 'medium' | 'extraLarge'
  image?: string | null
  className?: string
  string?: string
  squared?: boolean
  isLoading?: boolean
}

const Avatar = React.memo(
  ({
    size = 'small',
    image,
    className,
    isLoading,
    string,
    squared = false
  }: Props) => {
    const [isAvatarLoaded, setIsAvatarLoaded] = useState(true)
    useEffect(() => {
      if (!image) {
        setIsAvatarLoaded(false)
        return
      }
      const img = document.createElement('img')
      img.src = image
      img.onload = () => {
        setIsAvatarLoaded(true)
      }
      img.onerror = () => {
        setIsAvatarLoaded(false)
      }

      return () => {
        img.onload = null
        img.onerror = null
      }
    }, [image])

    const placeHolderVariant = useMemo(() => {
      switch (size) {
        case 'large': {
          return 'nextTitle-1'
        }
        case 'extraLarge': {
          return 'header-2'
        }
        default: {
          return 'nextTitle-3'
        }
      }
    }, [size])

    return (
      <div
        data-testid={`avatar-${image || string || ''}`}
        className={clsx(
          Styles.avatar,
          Styles[size],
          {
            [Styles.squared]: squared
          },
          className
        )}
        style={{
          ...(image && !isLoading && { backgroundImage: `url("${image}")` })
        }}>
        {isLoading && <Spinner size="medium" color="white" />}
        {string && !isAvatarLoaded && (
          <Text asChild variant={placeHolderVariant} weight="extraBold">
            <span>{string[0].toUpperCase()}</span>
          </Text>
        )}
      </div>
    )
  }
)

Avatar.displayName = 'Avatar'
export default Avatar
